import * as React from 'react'

import { LeaveTypeFragment } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import PanesPadForm from 'modules/core/components/PanesPadForm'

import LeaveTypes from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes'

import LeaveTypesDescription from './LeaveTypesDescription'

const LeaveTypesBlock = ({ loading, data }: { loading: boolean; data: LeaveTypeFragment[] }) => {
  if (loading) return <Loading />

  return (
    <PanesPadForm direction="horizontal" compact>
      <LeaveTypesDescription />
      <LeaveTypes data={data} />
    </PanesPadForm>
  )
}

export default LeaveTypesBlock
